var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { AddRowComponent } from '../../../../component/addrow/addrow.component';
import { AddRowService, Item } from '../../../../component/addrow/addrow.service';
var KtsReportDownloadListComponent = /** @class */ (function (_super) {
    __extends(KtsReportDownloadListComponent, _super);
    function KtsReportDownloadListComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.checkboxKey = '';
        _this.noKey = '';
        _this.fileItem = new Item();
        return _this;
    }
    KtsReportDownloadListComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.checkboxKey = jsonpath.value(this.component, '$.params.checkboxKey') || '';
        this.noKey = jsonpath.value(this.component, '$.params.noKey') || '';
    };
    KtsReportDownloadListComponent.prototype.ngAfterViewInit = function () {
        this.modalFile = this.remodalFileElement.nativeElement;
        this.remodalFile = $(this.modalFile).remodal({ hashTracking: false });
    };
    KtsReportDownloadListComponent.prototype.onEvent = function (e1, e2, index) {
        var _this = this;
        if (e2 === 'bulk') {
            if (index === 'header') {
                var checked_1 = e1.target.checked;
                this.bulkElement.map(function (el, index) {
                    el.nativeElement.checked = checked_1;
                    _this.items[index][_this.checkboxKey] = checked_1;
                    _this.dispItems[index][_this.checkboxKey] = checked_1;
                });
            }
            else {
                var num = this.bulkElement.length;
                var checked_2 = 0;
                this.bulkElement.map(function (el, index) {
                    if (el.nativeElement.checked) {
                        checked_2++;
                    }
                    _this.items[index][_this.checkboxKey] = el.nativeElement.checked;
                    _this.dispItems[index][_this.checkboxKey] = el.nativeElement.checked;
                });
                var header = this.bulkHeaderElement.nativeElement;
                if (num === checked_2) {
                    header.indeterminate = false;
                    header.checked = true;
                }
                else if (num > checked_2 && checked_2 !== 0) {
                    header.indeterminate = true;
                    header.checked = false;
                }
                else {
                    header.checked = false;
                    header.indeterminate = false;
                }
            }
        }
        _super.prototype.onEvent.call(this, e1, e2, index);
        this.setNos(this.items);
        this.setNos(this.dispItems);
        this.setCompRec();
    };
    KtsReportDownloadListComponent.prototype.setUnsubscribe = function () {
        this.modeSubscription.unsubscribe();
    };
    // 報告書タイプの選択肢によって入力情報のreadonlyを切り替える
    KtsReportDownloadListComponent.prototype.onChangeSubscribe = function (compRec) {
        var _this = this;
        var data = compRec['ViewComp#type'];
        if (data) {
            var readonly_1 = false;
            if (data.report_type === '1' || data.report_type === '2') {
                readonly_1 = true;
            }
            for (var _i = 0, _a = this.cols; _i < _a.length; _i++) {
                var col = _a[_i];
                col.items[7].items.filter(function (item) { return _this.isInput(item.controlType); }).map(function (item) { return item.readonly = readonly_1; });
            }
        }
    };
    KtsReportDownloadListComponent.prototype.isInput = function (controlType) {
        return controlType === 'date' || controlType === 'text' || controlType === 'textarea';
    };
    // クリックされた写真をモーダルで表示する
    KtsReportDownloadListComponent.prototype.onClickCol = function (e, index, col) {
        var isImage = false;
        col.items.forEach(function (item) { if (item.controlType === 'img')
            isImage = true; });
        if (isImage) {
            this.fileItem = this.dispItems[index];
            this.remodalFile.open();
        }
    };
    // 選択番号を設定する
    KtsReportDownloadListComponent.prototype.setNos = function (items) {
        var count = 0;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item[this.checkboxKey]) {
                item[this.noKey] = ++count;
            }
            else {
                item[this.noKey] = undefined;
            }
        }
    };
    KtsReportDownloadListComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-report-download-list',
                    template: "<form id=\"{{ componentName }}\" *ngIf=\"cols?.length > 0\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'list'\" [col]=\"cols[0]\" [msg]=\"(msg | async)\"></column-formtitle>\n        </dt>\n        <dd class=\"form_dd\" addrowDir></dd>\n      </dl>\n    </div>\n  </div>\n  <div class=\"tableWrapper\">\n    <table class=\"tableWrapper_table\">\n      <thead>\n      <tr data-href=\"#\">\n        <!-- <th [hidden]=\"readonly || !sortKey\" scope=\"col\"></th> -->\n        <th [hidden]=\"readonly || !checkboxKey\" scope=\"col\" class=\"table_select\">\n          <input type=\"checkbox\" id=\"{{ componentName + '_bulk_header' }}\" class=\"formInputCheckbox\" (change)=\"onEvent($event, 'bulk', 'header')\" #bulkHeader>\n          <label for=\"{{ componentName + '_bulk_header' }}\" class=\"formInputCheckboxLabel\">\u3000</label>\n          <span *ngIf=\"cols[0].items.length==8\"> <a a class=\"-fixed\">\u5831\u544A\u66F8</a></span>\n          <span *ngIf=\"cols[0].items.length==5\"> <a a class=\"-fixed\">\u5199\u771F</a></span>\n          <label for=\"{{ componentName + '_bulk_header' }}\" class=\"formInputCheckboxIndeterminateLabel\"></label>\n        </th>\n        <th [hidden]=\"readonly || !deletable\" scope=\"col\"></th>\n        <ng-template ngFor let-col [ngForOf]=\"cols[0].items\">\n          <th *ngIf=\"col.readonly || (!col.readonly && !col.hidden)\" scope=\"col\">\n            <a a class=\"-fixed\">{{ col.label }}</a>\n          </th>\n        </ng-template>\n      </tr>\n      </thead>\n      <tbody>\n      <ng-template ngFor let-item [ngForOf]=\"dispItems\" let-index=\"index\">\n        <tr data-href=\"#\">\n          <!-- <td [hidden]=\"readonly || !sortKey\" class=\"tableWrapper_arrowTd\">\n            <ul class=\"stageFlow_arrows\"> -->\n              <!-- <li><a *ngIf=\"index > 0\" href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" (click)=\"onEvent($event, 'up', index)\"></a></li>\n              <li><a *ngIf=\"index < dispItems.length - 1\" href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" (click)=\"onEvent($event, 'down', index)\"></a></li> -->\n            <!-- </ul>\n          </td> -->\n          <td [hidden]=\"readonly || !checkboxKey\" class=\"table_select\">\n            <input type=\"checkbox\" name=\"{{ componentName + '_bulk' }}\" id=\"{{ componentName + '_bulk_' + index }}\" class=\"formInputCheckbox\" (change)=\"onEvent($event, 'bulk', index)\" [checked]=\"item.is_checked\" #bulk>\n            <label for=\"{{ componentName + '_bulk_' + index }}\" class=\"formInputCheckboxLabel\"></label>\n          </td>\n          <td [hidden]=\"readonly || !deletable\" class=\"tableWrapper_iconTd\">\n            <a *ngIf=\"item?.$editable\" href=\"javascript:void(0);\" (click)=\"onEvent($event, 'delete', index)\"><img src=\"img/icon_delete.svg\" alt=\"\" width=\"18\"></a>\n          </td>\n          <ng-template ngFor let-col [ngForOf]=\"cols[0].items\">\n            <td *ngIf=\"col.readonly || (!col.readonly && !col.hidden)\" [col]=\"col\" listDir>\n              <column [key]=\"'list'\" [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"{\n                key: col.key,\n                controlType: col.controlType,\n                dataType: col.dataType,\n                required: col.required,\n                readonly: col.readonly,\n                hidden: col.hidden,\n                params: col.params,\n                items: col.items\n              }\" [val]=\"item\" [msg]=\"(msg | async)\" [err]=\"errItems[index] || {}\" (setChangeVal)=\"onChangeRow($event, index)\" (clickCol)=\"onClickRow($event, index)\" (click)=\"onClickCol($event, index, col)\"></column>\n            </td>\n          </ng-template>\n        </tr>\n      </ng-template>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <p *ngIf=\"addable && !readonly && (maxRows === null || dispItems.length < maxRows)\">\n        <button class=\"addBtn\" type=\"button\" (click)=\"onEvent($event, 'add', '')\"></button>\n      </p>\n    </div>\n  </div>\n</form>\n\n<!-- remodal -->\n<div class=\"remodal\" id=\"{{ componentName + '#Remodal#File' }}\" #remodalFile>\n  <div class=\"remodal_whitebg\">\n    <column [key]=\"'form'\" [col]=\"{\n      key: 'file',\n      controlType: 'img'\n    }\" [val]=\"fileItem\" [msg]=\"(msg | async)\"></column>\n  </div>\n  <div class=\"remodal_btns\">\n    <ul class=\"remodal_btns_group\">\n      <li>\n        <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\">{{ (msg | async)['Modal.button.cancel'] }}</button>\n      </li>\n    </ul>\n  </div>\n</div>\n<!-- /remodal -->\n"
                }] }
    ];
    /** @nocollapse */
    KtsReportDownloadListComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: AddRowService }
    ]; };
    KtsReportDownloadListComponent.propDecorators = {
        bulkHeaderElement: [{ type: ViewChild, args: ['bulkHeader',] }],
        bulkElement: [{ type: ViewChildren, args: ['bulk',] }],
        remodalFileElement: [{ type: ViewChild, args: ['remodalFile',] }]
    };
    return KtsReportDownloadListComponent;
}(AddRowComponent));
export { KtsReportDownloadListComponent };
//# sourceMappingURL=report-download-list.component.js.map